import { lazy } from 'react'

export { default as EventTypeRootScreen } from './event-type-root-screen/event-type-root-screen'

const EventsGuideScreen = lazy(() => import('./events-guide-screen/events-guide-screen'))
const EventsListScreen = lazy(() => import('./events-list-screen/events-list-screen'))
const EventItemScreen = lazy(() => import('./event-item-screen/event-item-screen'))

export { EventsGuideScreen, EventsListScreen, EventItemScreen }
